import { types } from "../actions";
const initialState = {
  activatedSensors: [],
  showSensorActivatedModal: false,
  activationStatusMessage:
    "Your requested sensor activation failed. Please try again.",
  activatedBleSensors: {},
};
// eslint-disable-next-line import/no-anonymous-default-export
const deviceReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.ACTIVATE_SENSOR_SUCCESS: {
      return {
        ...state,
        activatedSensors: [...state.activatedSensors, action.payload],
        showSensorActivatedModal: true,
      };
    }
    case types.SET_SHOW_SENSOR_ACTIVATE_MODAL: {
      return {
        ...state,
        showSensorActivatedModal: action.payload?.showSensorActivatedModal,
        activationStatusMessage:
          action.payload?.activationStatusMessage ||
          state.activationStatusMessage,
      };
    }
    case types.ACTIVATE_BLE_SENSOR: {
      const {sensor} = action.state
      return {
        ...state,
        activatedBleSensors: {sensor},
      };
    }
    default:
      return state;
  }
};
export default deviceReducer;
